var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"conditions"},[_c('div',{staticClass:"text"},_vm._l((_vm.conditions),function(condition,index){return _c('div',{key:index,staticClass:"li flex"},[_c('div',{staticClass:"sli top lundi"},[_vm._v(_vm._s(condition.title))]),_c('div',{staticClass:"sli",domProps:{"innerHTML":_vm._s(condition.text)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }